export default String.raw`
{% comment -%} Fallback to another related objects {% endcomment -%}

{% assign relatedProducts = product-presentation.Product.RelatedProducts -%}

{% assign showAiGeneratedContent = false -%}
{% assign reccomendedProducts = null -%}

{% if relatedProducts -%}
    {% if relatedProducts['AIProductsRecommendations'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['AIProductsRecommendations'] -%}
        {% assign showAiGeneratedContent = true -%}
    {% elseif relatedProducts['Crossselling'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['Crossselling'] -%}
        {% assign showAiGeneratedContent = true -%}
    {% elseif relatedProducts['Suggested'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['Suggested'] -%}
    {% elseif relatedProducts['Accessories'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['Accessories'] -%}
    {% elseif relatedProducts['Substitutes'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['Substitutes'] -%}
    {% elseif relatedProducts['Custom'] != empty -%}
        {% assign reccomendedProducts = relatedProducts['Custom'] -%}
    {% endif -%}

    {% if reccomendedProducts != empty -%}
        <h4 class="ai-reccommended-in-popup__title">{{ translations.AddToOrder }}</h4>
        <div class="ai-reccommended-in-popup ai-reccommended-in-popup-js swiper">
            <div class="ai-reccommended-in-popup-list__wrapper swiper-wrapper">
                {% include 'partials/product/AI-recommended-item.html' for reccomendedProducts -%}
            </div>
            {% if showAiGeneratedContent and config.Products.AIEnabled -%}
                <div class="ai-generated-content">{{ translations.AiGeneratedProductsRecommendations }}</div>
            {% endif -%}
        </div>
        <script>
            if ($('body').find('.ai-reccommended-in-popup-js').length > 0) {
                const recommendedSliderInPopup = new Swiper(".ai-reccommended-in-popup-js", {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    grabCursor: true
                });
            }
        </script>
    {% endif -%}
{% endif -%}
`